export const BOS_HOSTS = [
    /\.bcebos\.com$/, /\.bdimg\.com$/,
    'feed-image.baidu.com', 'aod-image.baidu.com',
    'vcp.baidu.com', 'jmy-pic.baidu.com'
];

export const platformProtocolPath = '/userCenter/aboutUs?active=platformProtocol';